import styled from 'styled-components';
import ButtonGroup from 'components/ButtonGroup';
import { Select, media } from '@minerva-analytics/pantheon';
import { ORANGE, WHITE } from 'root/theme';

const CategorySelectionContainer = styled.div`
  margin-right: 3.5rem;


  ${media.medium`
    width: 100%;
    margin: 0;
  `}
`;

const CategoryButtonGroup = styled(ButtonGroup).attrs({
  color: ORANGE,
})`
  width: 12rem;
`;

const CategorySelectDropdown = styled(Select).attrs({
  color: WHITE,
})`
  width: 100%;
  max-width: 400px;
  border-radius: 30px;
  padding: 0 20px;
  font-weight: 800;
  color: ${WHITE};
  background-color: ${ORANGE};
`;

export {
  CategorySelectionContainer,
  CategorySelectDropdown,
  CategoryButtonGroup,
};
